export const TYPE = {
  CUSTOMER_RATING: 'customer_rating',
  AI_RATING: 'ai_rating',
};
